var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20980_149629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.89474 15.5449L0 16.501H17.9442L16.1823 15.5449H1.89474Z",
    fill: "#06251E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8311 2.62109H2.52051V15.8457H15.8311V2.62109Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.61619 15.5755L7.56323 13.8223L15.8311 13.8324V15.6309L7.61619 15.5755Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74786 13.9883H7.69067V14.3573H8.74786V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0566 13.9883H8.97778V14.3573H10.0566V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3654 13.9883H10.2866V14.3573H11.3654V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.674 13.9883H11.5952V14.3573H12.674V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9826 13.9883H12.9038V14.3573H13.9826V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2912 13.9883H14.2124V14.3573H15.2912V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.831 13.9883H15.521V14.3573H15.831V13.9883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14647 14.4668H7.69067V14.8359H8.14647V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45552 14.4668H8.37671V14.8359H9.45552V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7641 14.4668H9.6853V14.8359H10.7641V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0727 14.4668H10.9939V14.8359H12.0727V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3813 14.4668H12.3025V14.8359H13.3813V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6901 14.4668H13.6113V14.8359H14.6901V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8311 14.4668H14.9199V14.8359H15.8311V14.4668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74786 14.9668H7.69067V15.3359H8.74786V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0566 14.9668H8.97778V15.3359H10.0566V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3654 14.9668H10.2866V15.3359H11.3654V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.674 14.9668H11.5952V15.3359H12.674V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9826 14.9668H12.9038V15.3359H13.9826V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2912 14.9668H14.2124V15.3359H15.2912V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.831 14.9668H15.521V15.3359H15.831V14.9668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.14647 15.4453H7.69067V15.8144H8.14647V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45552 15.4453H8.37671V15.8144H9.45552V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7641 15.4453H9.6853V15.8144H10.7641V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0727 15.4453H10.9939V15.8144H12.0727V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3813 15.4453H12.3025V15.8144H13.3813V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6901 15.4453H13.6113V15.8144H14.6901V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9987 15.4453H14.9199V15.8144H15.9987V15.4453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8311 2.62109V3.38841L3.89445 15.8455H2.52051V2.62109H15.8311Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.8313 2.93158V6.69879C15.5938 6.62137 15.3861 6.46679 15.2385 6.25758C15.091 6.04837 15.0114 5.79547 15.0112 5.53572C15.0112 5.85873 14.8882 6.16852 14.6694 6.39692C14.4505 6.62533 14.1536 6.75364 13.8441 6.75364C13.5346 6.75364 13.2377 6.62533 13.0189 6.39692C12.8 6.16852 12.677 5.85873 12.677 5.53572C12.673 5.85595 12.5483 6.16166 12.3299 6.38664C12.1115 6.61162 11.817 6.73777 11.5101 6.73777C11.2032 6.73777 10.9086 6.61162 10.6902 6.38664C10.4718 6.16166 10.3471 5.85595 10.3431 5.53572C10.3391 5.85595 10.2144 6.16166 9.99597 6.38664C9.77756 6.61162 9.48302 6.73777 9.17613 6.73777C8.86923 6.73777 8.57469 6.61162 8.35628 6.38664C8.13786 6.16166 8.01316 5.85595 8.00915 5.53572C8.00915 5.85873 7.88619 6.16852 7.66733 6.39692C7.44846 6.62533 7.15161 6.75364 6.84208 6.75364C6.53256 6.75364 6.23571 6.62533 6.01684 6.39692C5.79797 6.16852 5.67501 5.85873 5.67501 5.53572C5.67501 5.85873 5.55205 6.16852 5.33319 6.39692C5.11432 6.62533 4.81747 6.75364 4.50794 6.75364C4.19841 6.75364 3.90156 6.62533 3.6827 6.39692C3.46383 6.16852 3.34087 5.85873 3.34087 5.53572C3.34083 5.79553 3.26121 6.04853 3.11362 6.25778C2.96604 6.46702 2.75822 6.62155 2.52051 6.69879V2.93158L2.702 2.62109H15.6503L15.8313 2.93158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3491 4.79744H1.00317L2.50347 2.22331L2.96839 1.42578H15.3837L15.4049 1.46221L15.4442 1.52948L17.3491 4.79744Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0111 4.79744H3.34082L4.45652 2.11651L4.74412 1.42578H13.608L13.6901 1.62263L15.0111 4.79744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6772 4.79744H5.6748L6.36981 2.01363L6.51659 1.42578H11.8354L11.9084 1.71764L12.6772 4.79744Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3427 4.79744H8.00854L8.24874 1.91283L8.28921 1.42578H10.0622L10.0946 1.8143L10.3427 4.79744Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1745 6.0148C2.32776 6.0148 2.47953 5.9833 2.62112 5.92209C2.76272 5.86089 2.89137 5.77117 2.99975 5.65808C3.10812 5.54498 3.19408 5.41072 3.25274 5.26296C3.31139 5.11519 3.34157 4.95682 3.34157 4.79688H1.00684C1.00684 4.95687 1.03704 5.11529 1.09573 5.2631C1.15442 5.41091 1.24044 5.5452 1.34887 5.6583C1.45731 5.7714 1.58604 5.8611 1.7277 5.92227C1.86936 5.98344 2.02119 6.01489 2.1745 6.0148Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.50789 6.0148C4.81742 6.0148 5.11427 5.88649 5.33314 5.65808C5.552 5.42967 5.67496 5.11989 5.67496 4.79688H3.34082C3.34087 5.11987 3.46385 5.42963 3.68271 5.65802C3.90156 5.88641 4.19838 6.01475 4.50789 6.0148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84212 6.0148C7.15161 6.01475 7.44841 5.88641 7.66724 5.65801C7.88606 5.42961 8.00899 5.11985 8.00899 4.79688H5.67505C5.67505 5.11989 5.79801 5.42967 6.01688 5.65808C6.23575 5.88649 6.53259 6.0148 6.84212 6.0148Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.17606 6.0148C9.48558 6.0148 9.78243 5.88649 10.0013 5.65808C10.2202 5.42967 10.3431 5.11989 10.3431 4.79688H8.00879C8.00884 5.11991 8.13184 5.42969 8.35074 5.65809C8.56964 5.88649 8.86651 6.0148 9.17606 6.0148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5101 6.0148C11.8196 6.01475 12.1164 5.88641 12.3352 5.65801C12.554 5.42961 12.677 5.11985 12.677 4.79688H10.343C10.343 4.95682 10.3732 5.11519 10.4319 5.26296C10.4905 5.41072 10.5765 5.54498 10.6848 5.65808C10.7932 5.77117 10.9219 5.86089 11.0635 5.92209C11.2051 5.9833 11.3568 6.0148 11.5101 6.0148Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8441 6.0148C14.1536 6.0148 14.4504 5.88649 14.6693 5.65808C14.8882 5.42967 15.0111 5.11989 15.0111 4.79688H12.677C12.6771 5.11987 12.8 5.42963 13.0189 5.65802C13.2377 5.88641 13.5346 6.01475 13.8441 6.0148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1779 6.0148C16.4874 6.01475 16.7842 5.88641 17.0031 5.65802C17.2219 5.42963 17.3449 5.11987 17.345 4.79688H15.0112C15.0112 5.11982 15.1341 5.42954 15.3529 5.65793C15.5717 5.88633 15.8684 6.01469 16.1779 6.0148Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.4439 1.52948L13.6897 1.62263L11.908 1.71764L10.0943 1.8143L8.24966 1.91283L6.37052 2.01363L4.45707 2.11713C3.6619 2.16039 2.98633 2.19723 2.50415 2.22393L2.96788 1.42578H14.1598L15.4044 1.46221L15.4439 1.52948Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 1.48527H2.88295L2.52295 0.607422L15.6803 0.644266L15.4688 1.48527Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4935 15.3887H1.85791V15.844H16.4935V15.3887Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.02997 15.1208L2.69436 15.1272L2.65747 15.3855H5.58685L5.33614 7.64951L3.43677 7.23242L2.75744 7.71015L2.69238 8.36134H3.16841L3.02997 15.1208Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51047 15.3864L7.33573 8.22085L7.32403 7.74126L3.78275 7.65039L3.76926 8.36223L3.63696 15.3864H7.51047Z",
    fill: "#C8DED8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.32399 15.2452H3.78271L3.82774 13.2335L3.94972 7.80664H7.15282L7.31229 14.7346L7.32399 15.2452Z",
    fill: "#06251E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.31229 14.7335L5.28559 14.5667L3.82774 13.2324L3.78271 15.2442H7.32399L7.31229 14.7335Z",
    fill: "#43927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.09302 14.8857L4.09758 14.6553L4.13487 12.6889L4.15252 11.7447L4.18406 10.0803L4.19556 9.47294L4.22254 8.04492H6.88792L6.89248 8.74455L6.89645 9.3206L6.91331 11.7759L6.92858 13.9984L6.93433 14.8857H4.09302Z",
    fill: "#94CEBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.81874 14.6916H4.21167L4.21226 14.6616L4.22159 14.1716L4.24003 13.1932L4.24936 12.6946L4.26721 11.7505L4.28188 10.9745L4.29061 10.509L4.29855 10.0859L4.3041 9.79609L4.31025 9.47877L4.32235 8.84207L4.33365 8.23828H6.7747L6.77609 8.4608L6.77808 8.74623L6.78065 9.12937L6.78204 9.32249L6.78264 9.39929L6.79811 11.6681L6.7989 11.7778L6.80287 12.3632L6.81418 14.0003L6.81874 14.6916Z",
    fill: "url(#paint0_linear_20980_149629)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.77619 8.4608L4.3042 9.79609L4.31035 9.47877L4.32245 8.84207C4.77111 8.64812 5.27451 8.43037 5.71682 8.23828H6.77481L6.77619 8.4608Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.78274 9.40077L4.28198 10.976L4.29071 10.5104L6.78075 9.13086L6.78214 9.32398L6.78274 9.40077Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M6.80296 12.363L4.22168 14.1715L4.24013 13.1931L6.7982 11.668L6.79899 11.7777L6.80296 12.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M7.3358 8.22086L7.16265 8.22851L6.98037 8.23638L6.85838 8.24155C6.4601 8.25853 6.04001 8.27633 5.63439 8.29289L5.1883 8.3109C4.84576 8.32456 4.52503 8.33677 4.25072 8.3465L4.12834 8.35085L3.93753 8.35705C3.87803 8.35912 3.8215 8.36078 3.76953 8.36223L3.78282 7.65039L7.3241 7.74126L7.3358 8.22086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74502 7.87202H3.3562L3.39706 7.54829L3.43673 7.23242L7.65715 7.28293L7.70078 7.57478L7.74502 7.87202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74501 7.87256H3.3562L3.39706 7.54883C3.64341 7.58898 3.98436 7.64487 4.00003 7.65563C4.02443 7.67219 6.33675 7.69703 6.33675 7.69703L7.70078 7.5747L7.74501 7.87256Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.04126 8.68799L8.2529 13.71L14.5131 13.7652L14.7797 8.55469L8.04126 8.68799Z",
    fill: "#DFF0EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0449 7.87305L15.03 8.16221L14.7783 13.0836L8.51808 13.0283L8.33976 8.79394L8.30664 8.00635L15.0449 7.87305Z",
    fill: "#06251E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7724 8.14453L14.7436 8.80048L14.7295 9.1209L14.6176 11.6677L14.5855 12.3973L14.5661 12.844L13.8332 12.8302L12.6867 12.8082L9.6558 12.7503L9.09785 12.7395L8.78328 12.7335L8.74738 11.9687L8.71703 11.3222L8.67557 10.4376L8.65078 9.90974L8.61488 9.14636L8.57104 8.2118L10.6116 8.18986L11.8384 8.17641L12.7746 8.16626L13.7179 8.15592L14.7041 8.14536L14.7724 8.14453Z",
    fill: "url(#paint1_linear_20980_149629)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6117 8.19119L8.61499 9.14769L8.65089 9.91107L11.8385 8.17773L10.6117 8.19119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7748 8.16722C11.7513 8.73706 9.8248 9.80803 8.67578 10.4385L8.71723 11.3232L13.7183 8.15625L12.7748 8.16722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5662 12.8451L14.586 12.3984L13.8335 12.8313L14.5662 12.8451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6869 12.8084L14.6178 11.6679L14.7297 9.12109L9.65601 12.7505L12.6869 12.8084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7043 8.14536L8.74756 11.9687L8.78346 12.7335L9.09804 12.7395L14.7438 8.80048L14.7725 8.14453L14.7043 8.14536Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.0449 7.87305L15.03 8.16221L8.33976 8.79394L8.30664 8.00635L15.0449 7.87305Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3795 7.41797L15.2976 7.80276L15.2734 7.91619L7.97046 8.02445V7.5492L15.3795 7.41797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2976 7.80368L15.2734 7.91711L7.97046 8.02537V7.72461L15.2976 7.80368Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20980_149629",
    x1: 5.5152,
    y1: 15.0147,
    x2: 5.5152,
    y2: 7.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#347561"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3FC1C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20980_149629",
    x1: 11.6716,
    y1: 8.07167,
    x2: 11.6716,
    y2: 12.7867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#367F6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3EB6B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20980_149629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStore);
export default __webpack_public_path__ + "static/media/store.7ee3381c8ff28c344225bc24aa9ede7c.svg";
export { ForwardRef as ReactComponent };